import * as moment from 'moment';
import { useEffect, useState } from 'react';
import { IWatrRequestAuditLog, IListItem } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Panel, Row } from 'react-bootstrap';

interface IProps {
    data: IWatrRequestAuditLog,
    auditLogTypes: IListItem[],
    onSave: (type: number, comments: string, file: any) => void,
    onCancel: () => void
}

const AuditEntry = (props: IProps) => {
    const [type, setType] = useState(0);
    const [comment, setComment] = useState('');
    const [file, setFile] = useState<File>(null);
    const [validType, setValidType] = useState(true);
    const [validComment, setValidComment] = useState(true);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        let logType = props.data != null ? props.data.logType : 3;
        let comment = props.data != null ? props.data.logMessage : '';

        setType(logType);
        setComment(comment);
        setValidType(true);
        setValidComment(true);
        setDirty(false);
    }, [props.data]);

    let buttonLabel = props.data == null ? 'Add' : 'Update';
    let disableSave = comment == null;

    const handleInputChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (name == 'type') {
            setType(parseInt(value));
        }

        if (name == 'comment') {
            setComment(value);
        }

        if (name == 'file') {
            setFile(e.currentTarget.files[0]);
        }
    }

    const handleSave = () => {
        let updatedValidType = type > 0;
        let updatedValidComment = comment != '';

        setValidType(updatedValidType);
        setValidComment(updatedValidComment);
        setDirty(true);

        if (updatedValidType && updatedValidComment) {
            props.onSave(type, comment, file);
        }
    }

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                {props.data == null ? 'Add Log Entry' : 'Edit Log Entry'}
            </Panel.Heading>
            <Panel.Body style={{ paddingBottom: '0px' }}>
                {dirty && (validType == false || validComment == false) && (
                    <Alert bsStyle='danger' bsSize='sm'>The items in red are required...</Alert>
                )}

                <Form>
                    {props.data != null && props.data.updatedDate != '' && (
                        <div style={{ marginBottom: 10 }}>Last Updated: <strong>{moment(props.data.updatedDate).format('MM/DD/YYYY')}</strong> by <strong>{props.data.updatedByAlias}</strong></div>
                    )}

                    <FormGroup validationState={dirty && validType == false ? 'error' : null}>
                        <ControlLabel>Type</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='type'
                            value={type}
                            onChange={handleInputChange}>
                            <option value={0}>- Select Type -</option>
                            {props.auditLogTypes.filter(x => x.id > 0).map(item =>
                                <option value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>

                    <FormGroup validationState={dirty && validComment == false ? 'error' : null}>
                        <ControlLabel>Comment</ControlLabel>
                        <FormControl
                            name='comment'
                            componentClass='textarea'
                            placeholder='Additional notes...'
                            rows={6}
                            style={{ resize: 'none' }}
                            value={comment}
                            onChange={handleInputChange}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>File</ControlLabel>
                        <FormControl
                            id='formControlsFile'
                            name='file'
                            type='file'
                            label='File'
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Form>
            </Panel.Body>
            <Panel.Footer style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                <div className='text-right'>
                    <Button bsStyle='primary' bsSize='sm' disabled={disableSave} style={{ marginRight: 5 }} onClick={handleSave}>
                        {buttonLabel}
                    </Button>
                    <Button bsSize='sm' onClick={props.onCancel}>Cancel</Button>
                </div>
            </Panel.Footer>
        </Panel>
    );
}

export default AuditEntry;